import * as React from 'react'

import { cn } from '@/lib/utils'
import { useContrastedBackground } from 'app/frontend/base/components/Card'

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  disabled?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const background = useContrastedBackground()

    return (
      <input
        type={type}
        autoComplete='off'
        aria-autocomplete='none'
        className={cn(
          'flex h-10 w-full rounded-md border px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          background,
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
